// src/services/permissions/adminPermissionService.js
// Super admin permission checking service

import { supabase } from '../../config';

/**
 * Check if user has super admin role
 * @param {string} userId - User ID to check
 * @returns {Promise<boolean>} Whether user is super admin
 */
export const checkSuperAdmin = async (userId) => {
    try {
        const { data, error } = await supabase
            .from('user_profiles')
            .select('is_super_admin')
            .eq('id', userId)
            .single();
        
        if (error) throw error;
        return data?.is_super_admin === true;
    } catch (error) {
        console.error('Error checking super admin:', error);
        return false;
    }
};
